const r = {
  common: {
    primaryColor: "#FC9153",
    primaryColorHover: "#FC9153",
    primaryColorPressed: "#FC9153",
    primaryColorSuppl: "#FC9153"
  }
};
export {
  r as themeOverrides
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/constants/themeConfig.js
// module id = 418
// module chunks = 41